import * as Types from '../../../util/graphql/api.graphql';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';

export const UpdateObservationDocument = gql`
  mutation UpdateObservation($observation: ObservationIn!) {
    updateObservation(observation: $observation) {
      id
      code {
        coding {
          system
          code
          display
        }
      }
      extension {
        url
        valueString
        valueAnnotation {
          text
        }
      }
      component {
        code {
          coding {
            code
            system
            display
          }
        }
        valueString
        valueCodeableConcept {
          coding {
            code
            system
            display
          }
        }
        valueQuantity {
          value
          system
          code
        }
      }
      effectiveDateTime
      status
      resourceType
      meta {
        tag {
          system
          code
        }
        lastUpdated
        versionId
      }
      subject {
        reference
      }
    }
  }
`;
export type UpdateObservationMutationFn = ApolloReactCommon.MutationFunction<
  UpdateObservationMutationResponse,
  UpdateObservationMutationVariables
>;

/**
 * __useUpdateObservationMutation__
 *
 * To run a mutation, you first call `useUpdateObservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateObservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateObservationMutation, { data, loading, error }] = useUpdateObservationMutation({
 *   variables: {
 *      observation: // value for 'observation'
 *   },
 * });
 */
export function useUpdateObservationMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateObservationMutationResponse,
    UpdateObservationMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    UpdateObservationMutationResponse,
    UpdateObservationMutationVariables
  >(UpdateObservationDocument, baseOptions);
}
export type UpdateObservationMutationHookResult = ReturnType<
  typeof useUpdateObservationMutation
>;
export type UpdateObservationMutationResult =
  ApolloReactCommon.MutationResult<UpdateObservationMutationResponse>;
export type UpdateObservationMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpdateObservationMutationResponse,
    UpdateObservationMutationVariables
  >;
export type UpdateObservationMutationVariables = Types.Exact<{
  observation: Types.ObservationIn;
}>;

export type UpdateObservationMutationResponse = {
  __typename: 'Mutation';
  updateObservation: {
    __typename: 'Observation';
    id?: Types.Maybe<string>;
    effectiveDateTime?: Types.Maybe<string>;
    status?: Types.Maybe<Types.ObservationStatus>;
    resourceType: Types.ObservationResourceType;
    code?: Types.Maybe<{
      __typename: 'CodeableConcept';
      coding?: Types.Maybe<
        Array<{
          __typename: 'Coding';
          system?: Types.Maybe<string>;
          code?: Types.Maybe<string>;
          display?: Types.Maybe<string>;
        }>
      >;
    }>;
    extension?: Types.Maybe<
      Array<{
        __typename: 'Extension';
        url?: Types.Maybe<string>;
        valueString?: Types.Maybe<string>;
        valueAnnotation?: Types.Maybe<{
          __typename: 'Annotation';
          text?: Types.Maybe<string>;
        }>;
      }>
    >;
    component?: Types.Maybe<
      Array<{
        __typename: 'ObservationComponent';
        valueString?: Types.Maybe<string>;
        code?: Types.Maybe<{
          __typename: 'CodeableConcept';
          coding?: Types.Maybe<
            Array<{
              __typename: 'Coding';
              code?: Types.Maybe<string>;
              system?: Types.Maybe<string>;
              display?: Types.Maybe<string>;
            }>
          >;
        }>;
        valueCodeableConcept?: Types.Maybe<{
          __typename: 'CodeableConcept';
          coding?: Types.Maybe<
            Array<{
              __typename: 'Coding';
              code?: Types.Maybe<string>;
              system?: Types.Maybe<string>;
              display?: Types.Maybe<string>;
            }>
          >;
        }>;
        valueQuantity?: Types.Maybe<{
          __typename: 'Quantity';
          value?: Types.Maybe<number>;
          system?: Types.Maybe<string>;
          code?: Types.Maybe<string>;
        }>;
      }>
    >;
    meta?: Types.Maybe<{
      __typename: 'Meta';
      lastUpdated?: Types.Maybe<string>;
      versionId?: Types.Maybe<string>;
      tag?: Types.Maybe<
        Array<{
          __typename: 'Coding';
          system?: Types.Maybe<string>;
          code?: Types.Maybe<string>;
        }>
      >;
    }>;
    subject?: Types.Maybe<{
      __typename: 'Reference';
      reference?: Types.Maybe<string>;
    }>;
  };
};
